<template>
    <div>
        <LfcnvncInfoWin ref="facilityInfoWin"
                         v-on:loaded-facility-info="loadedFacilityInfoHandle" />
        <LfcnvncPharInfoWin ref="facilityPharInfoWin"
                         v-on:loaded-facility-info="loadedFacilityInfoHandle" />
    </div>
</template>

<script>
import { $_TYPE, $_NM, $_WC } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import LfcnvncInfoWin from '@/views/lfcnvnc/LfcnvncInfoWin.vue';
import LfcnvncPharInfoWin from '@/views/lfcnvnc/LfcnvncPharInfoWin.vue';
import gripUtil from "@/libs/grip.util";

export default {
    components: {
        LfcnvncInfoWin,
        LfcnvncPharInfoWin,
    },
    data() {
        return {
            searchVal: '',
        }
    },
    computed: {
        ...mapGetters({
            selectedLfcnvncItems: 'getSelectedLfcnvncItems',
            selectedHpCate: 'getSelectedHpCate',
            h01List: 'getH01List',
            h02List: 'getH02List',
            h03List: 'getH03List',
            h04List: 'getH04List',
            h05List: 'getH05List',
            h06List: 'getH06List',
            p07List: 'getP07List',
            p08List: 'getP08List',
            p09List: 'getP09List',
            p10List: 'getP10List',
            p11List: 'getP11List',
            selectedLfcnvncTab: 'getSelectedLfcnvncTab',
        }),
        // roundRoad() {
        //     return gripUtil.toDict(this.roadMenuMap[this.selectedRoadCategory].roads, 'code');
        // },
        // roundRoadPointMap() {
        //     return gripUtil.toMap(this.roundRoadPointList, 'val1');
        // },
    },
    created() {
        this.$eventBus.$on('setFacilityInfo', (fac)=> {
            if(this.selectedHpCate == 'LFCNVNC_01') {
                this.$refs.facilityInfoWin.setFacilityInfo(fac);
            }
            if(this.selectedHpCate == 'LFCNVNC_02') {
                this.$refs.facilityPharInfoWin.setFacilityInfo(fac);
            }
        });
    },
    mounted() {
        this.$eventBus.$on('Set::Search::Value::HosPhar', searchVal => {
            this.searchVal = searchVal;
        });
    },
    watch: {
        selectedHpCate: {
            immediate: false,
            handler(newVal, oldVal) {
                // this.disableAllMarker();
                this.searchVal = '';
                this.$eventBus.$emit('Set::Empty');
            }
        },
        selectedLfcnvncItems: {
            immediate: false,
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    newVal.forEach(chkbox => {
                        this.setHpMarker(chkbox);
                    });
                });
            }
        },
        selectedLfcnvncTab: {
            immediate: false,
            handler(newVal, oldVal) {
                let centerLat = 37.493712000000002;
                let centerLng = 127.06533399999999;
                this.searchVal = '';
                this.$eventBus.$emit('Set::Empty');
                this.map.setCenter(new naver.maps.LatLng(centerLat, centerLng));
                this.$nextTick(() => {
                    if(newVal == 'hosPhar' && !!this.selectedLfcnvncItems) {
                        this.disableAllMarker();
                        this.selectedLfcnvncItems.forEach(chkbox => {
                            this.setHpMarker(chkbox);
                        });
                    }
                })
            }
        },
        searchVal: {
            immediate: false,
            handler(newVal, oldVal) {
                if(!!this.selectedLfcnvncItems) {
                    this.$nextTick(() => {
                        this.selectedLfcnvncItems.forEach(chkbox => {
                            this.setHpMarker(chkbox);
                        });
                    });
                }
            }
        }
    },
    methods: {
        setHpMarker(chkbox) {
            if(chkbox.checked && !!this.map) {
                this.removeAllMarker();
                let dataKdSqno = chkbox.dataKdSqno;
                let dataName = chkbox.name;
                if(!this.hasMarkers(dataKdSqno)) {
                    let dataList = this[dataKdSqno + 'List'];
                    if(!!this.searchVal) {
                        if(this.selectedHpCate == 'LFCNVNC_01') {
                            dataList = dataList.filter(d => {
                                return d.val2.includes(this.searchVal) || !!d.val32 && d.val32.includes(this.searchVal);
                            });
                        }
                        if(this.selectedHpCate == 'LFCNVNC_02') {
                            dataList = dataList.filter(d => {
                                return d.val1.includes(this.searchVal);
                            });
                        }
                    }
                    dataList.forEach(data => {
                        // 시설 정보 팝업
                        data.facItemNm = dataName;
                        let imgNm = dataKdSqno;
                        if(dataKdSqno.includes('h')) {
                            imgNm += this.isHosManage(data);
                            // console.log('imgNm', imgNm);
                            data.marker = this.makeMarker(dataKdSqno, data, function(){
                                this.$refs.facilityInfoWin.setFacilityInfo(data);
                            }.bind(this), 'marker_facility_' + imgNm + '.png', 'img/marker2/', $_NM.MARKER2_W, $_NM.MARKER2_H);
                        }
                        if(dataKdSqno.includes('p')) {
                            imgNm += this.isPharManage(data);
                            // console.log('imgNm', imgNm);
                            data.marker = this.makeMarker(dataKdSqno, data, function(){
                                this.$refs.facilityPharInfoWin.setFacilityInfo(data);
                            }.bind(this), 'marker_facility_' + imgNm + '.png', 'img/marker2/', $_NM.MARKER2_W, $_NM.MARKER2_H);
                        }
                        // console.log('imgNm', imgNm);
                        // data.marker = this.makeMarker(dataKdSqno, data, function(){
                        //     this.$refs.facilityInfoWin.setFacilityInfo(data);
                        // }.bind(this), 'marker_facility_' + imgNm + '.png', 'img/marker2/', $_NM.MARKER2_W, $_NM.MARKER2_H);
                    });
                    this.showMarkers(dataKdSqno, true);
                } else {
                    this.showMarkers(dataKdSqno, true);
                }
            } else {
                this.showMarkers(chkbox.dataKdSqno, false);
            }
        },
        loadedFacilityInfoHandle(content) {
            // console.log('content', content);
            this.openInfoWin(content);
        },
        isHosManage(fac) {
            let fromNm = '';
            let toNm = '';

            let date = new Date();
            let day = date.getDay();
            let nowTime = date.getHours();
            nowTime = Number(nowTime + '00');
            let returnVal = '';
            switch (day) {
                case 1:
                    fromNm = 'val14'; toNm = 'val15';
                    break;
                case 2:
                    fromNm = 'val16'; toNm = 'val17';
                    break;
                case 3:
                    fromNm = 'val18'; toNm = 'val19';
                    break;
                case 4:
                    fromNm = 'val20'; toNm = 'val21';
                    break;
                case 5:
                    fromNm = 'val22'; toNm = 'val23';
                    break;
                case 6:
                    fromNm = 'val24'; toNm = 'val25';
                    break;
                case 7:
                    fromNm = 'val26'; toNm = 'val27';
                    break;
                default:
                    fromNm = ''; toNm = '';
                    break;
            }
            if(!!fac[fromNm] && !!fac[toNm]) {
                if(Number(fac[fromNm]) <= nowTime && nowTime < Number(fac[toNm])) {
                    returnVal = '';
                } else {
                    returnVal = '_false';
                }
            } else {
                returnVal = '_false';
            }
            return returnVal;
        },
        isPharManage(fac) {
            let fromNm = '';
            let toNm = '';

            let date = new Date();
            let day = date.getDay();
            let nowTime = date.getHours();
            nowTime = Number(nowTime + '00');
            let returnVal = '';
            switch (day) {
                case 1:
                    fromNm = 'val5'; toNm = 'val6';
                    break;
                case 2:
                    fromNm = 'val7'; toNm = 'val8';
                    break;
                case 3:
                    fromNm = 'val9'; toNm = 'val10';
                    break;
                case 4:
                    fromNm = 'val11'; toNm = 'val12';
                    break;
                case 5:
                    fromNm = 'val13'; toNm = 'val14';
                    break;
                case 6:
                    fromNm = 'val15'; toNm = 'val16';
                    break;
                case 7:
                    fromNm = 'val17'; toNm = 'val18';
                    break;
                default:
                    fromNm = ''; toNm = '';
                    break;
            }
            if(!!fac[fromNm] && !!fac[toNm]) {
                if(Number(fac[fromNm]) <= nowTime && nowTime < Number(fac[toNm])) {
                    returnVal = '';
                } else {
                    returnVal = '_false';
                }
            } else {
                returnVal = '_false';
            }
            return returnVal;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
